import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "@mui/material";
import { ReactComponent as Vector } from "../../assets/images/Vector.svg";
import Button from "../UniversalComponents/DefaultButton";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { useFetchAllDeleteReasonsQuery, useUpdateDeleteOrArchiveMutation } from "../../utils/customer/customerTable";
import { getCompanyId, getOrganizationId, getUserToken } from "../../utils/utilityFunctions/localServices";
import { useDispatch, useSelector } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import { ReactComponent as LineIcon } from "../../assets/images/RedLineIcon.svg";

const DeleteDialogue = ({ openArchiveDialogue, onClose, isArchive, rowData, refetch, multiData, setMultiData }) => {
  const [formData, setFormData] = useState({
    Reason: "",
    Message: "",
  });

  const dispatch = useDispatch();

  // const [formErrors, setFormErrors] = useState({
  //   Reason: "",
  //   Message: "",
  // });

  const [errors, setErrors] = useState({
    Reason: true,
  });

  const reasonOptions = ["Test", "Test1", "Test2", "Test3"];
  const { data: ReasonOptions, isLoading, error } = useFetchAllDeleteReasonsQuery({});

  const [updateDeleteOrArchive, { data }] = useUpdateDeleteOrArchiveMutation();

  const toggleArchive = () => (isArchive && rowData.customer_status === "archived" ? "active" : "archived");

  const getArchiveTitle = (status) => {
    if (status === "active") {
      return "Unarchive";
    }
    return "archive";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "Reason" && value) {
      setErrors((prev) => ({ ...prev, Reason: false }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.Reason) {
      setErrors((prev) => ({ ...prev, Reason: true }));
      return;
    }

    console.log("Submitting form data:", formData);
    let customerIdArray = [];
    if (Object.keys(multiData).length === 0) {
      customerIdArray.push(rowData?.id);
    } else {
      customerIdArray = Object.keys(multiData);
    }

    const updateData = {
      statusType: isArchive ? toggleArchive() : "deleted",
      company_id: getCompanyId(),
      customer_ids: customerIdArray,
      reason: formData.Reason,
      user_remarks: formData.Message,
    };

    try {
      const result = await updateDeleteOrArchive({
        payload: updateData,
      }).unwrap();

      if (result?.success) {
        refetch();
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "success",
          })
        );

        setMultiData({});
        onClose();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "danger",
          })
        );
      }
    } catch (err) {
      console.error("Error:", err);

      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  return (
    <Dialog
      open={openArchiveDialogue}
      fullWidth
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "520px",
        },
      }}
    >
      <div className=" py-3 h-full">
        <div className="px-5">
          <div className="flex justify-between items-center py-1">
            <span className="text-434852 font-500 text-lg capitalize ">
              {isArchive ? getArchiveTitle(toggleArchive()) : "Delete"}
            </span>
            <button
              onClick={onClose}
              type="button"
              className="rounded-lg text-sm  ms-auto flex end-0 items-center"
              data-modal-hide="assets-modal"
            >
              <Vector />
              {/* <span className="sr-only flex float-end">Close modal</span> */}
            </button>
          </div>

          <p className="font-poppins text-14 font-400 text-[#666666] pb-1">
            Are you sure you want to {isArchive ? getArchiveTitle(toggleArchive()) : "Delete"}?
          </p>
        </div>

        <div className="border-b border-BECBD3 "></div>
        {!isArchive && (
          <div className=" pt-3  pl-4 mr-4">
            <div className="bg-[#FBEAEA] border border-[#F6B5B5] text-sm rounded-md p-3 leading-relaxed w-[493px] h-[62px] text-[#666666] flex items-start gap-2">
              <div className="mt-0.5">
                <LineIcon />
              </div>
              <div>
                <span className="text-[#DC2626] font-semibold">Warning:</span> This action cannot be undone. If you
                delete this it will remove all its associated data. And it will be permanently lost.
              </div>
            </div>
          </div>
        )}

        {/* Reason */}

        <div className="px-5">
          <form onSubmit={handleSubmit}>
            <div className="pt-2">
              {/* <h3 className="text-[#434852] text-base">Reason</h3> */}
              <label htmlFor="reason" className="block text-base font-400 text-434852 mb-2">
                Reason <span className="mb-1 text-red-500">{errors.Reason && "*"} </span>
                {/* {false && <span className="text-red-500"></span>} */}
              </label>
              <select
                id="reason"
                name="Reason"
                value={formData.Reason}
                onChange={handleChange}
                className="w-full rounded-md text-sm font-400 text-#434852 px-4 py-1 cursor-pointer"
                required
              >
                <option value="" disabled>
                  Select a reason
                </option>
                {ReasonOptions?.data?.map((reason, index) => (
                  <option key={index} value={reason} className="cursor-pointer">
                    {reason}
                  </option>
                ))}
              </select>
            </div>

            {/*Message field  */}

            <div>
              <h3 className="text-[#434852] text-base mt-2">Add a Message</h3>
              <textarea
                className="bg-white rounded border border-DFE2E5 placeholder-AFAFAF text-sm block w-full p-2.5"
                rows="7"
                type="message"
                name="Message"
                id="description"
                placeholder="Enter Message"
                onChange={handleChange}
                value={formData.Message}
              />
            </div>

            {/* submit button */}
            <div className="flex justify-end py-3">
              <button
                onClick={onClose}
                type="button"
                className="px-6 py-1 text-16 rounded-5px font-500 bg-F4F4F4 focus:outline-none me-2"
              >
                CANCEL
              </button>
              <Button size="large" className={"px-4 py-1"} variant={isArchive ? "primary" : "red"} type="submit">
                Yes, {isArchive ? getArchiveTitle(toggleArchive()) : "Delete"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteDialogue;
